import FigmaBlocksIcon from 'components/Icons/FigmaBlocksIcon';

interface Properties {
  width?: number;
  height?: number;
}

const BlocksIcon = ({ width = 16, height = 16 }: Properties) => {
  return <FigmaBlocksIcon width={width} height={height} color='#121826' />;
};

export default BlocksIcon;
